import React from 'react';
import { useIntl } from 'react-intl';
import { BlockDataForm } from '@plone/volto/components';

import schemaContextNavigation from './schema';

export interface ContextNavigationDataProps {
  block: string;
  data: Record<string, unknown>;
  onChangeBlock: (block: string, data: Record<string, unknown>) => void;
}

const ContextNavigationData: React.FC<ContextNavigationDataProps> = ({
  block,
  data,
  onChangeBlock,
  ...rest
}) => {
  const intl = useIntl();

  const schema = schemaContextNavigation({
    ...rest,
    intl,
  });

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id: string, value: unknown) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default ContextNavigationData;
